import { type SupportedLocale } from '@zep-us/i18n';

import type { CategoryTreeBuildDto } from '@/api/gen/_model/categoryTreeBuildDto';

export const getSubjectLocaleName = ({
  defaultName,
  localizeNames,
  locale,
}: Pick<CategoryTreeBuildDto, 'localizeNames'> & {
  locale: SupportedLocale;
  defaultName: string;
}) => {
  if (locale === 'en') {
    return localizeNames?.[locale] ?? defaultName;
  }
  return defaultName;
};
